import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M376-140h207v-56l36-15q74-31 121.5-80.5T808-400H152q20 59 68 109t120 80l36 15v56Zm-60 60v-78q-105-42-167-122T80-460h80v-340l720-80v50l-470 52v87h470v50H410v181h470q-6 100-69.5 180T643-158v78H316Zm-6-611h50v-82l-50 6v76Zm-100 0h50v-71l-50 6v65Zm100 231h50v-181h-50v181Zm-100 0h50v-181h-50v181Zm270 60Z"
  })
}), "RamenDining");